import React from 'react';

export default function SVGPhone(): JSX.Element {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      className="text-iconStrong fill-current"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect height="30" x="9" width="18" y="3" rx="3" />
      <rect x="11.25" y="7" width="13.5" height="22" fill="#ffffff" />
      <circle cx="18" cy="5" r="0.744369" fill="#ffffff" />
    </svg>
  );
}
